'use client';
import { ButtonProps } from '@/components/Button/Button';
import Table, { PartialRowData } from '@/components/Table/Table';
import PlusCircle from '@/components/icons/PlusCircle';
import { NotifsContext } from '@/contexts';
import useNavigate from '@/hooks/useNavigate';
import {
  PdvPayload,
  useAddPdvMutation,
  useGetListRetailersQuery,
} from '@/services/API';
import { useAppSelector } from '@/store/hooks';
import { IRetail } from '@/types';
import { getURLParams } from '@/utils/router';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { useContext, useEffect, useState } from 'react';

type RetailTableData = IRetail & PartialRowData;

export default function Page() {
  const selectedSte = useAppSelector((state) => state.selectedSte.societe);
  const searchParams = getURLParams();
  const [tableData, setTableData] = useState<RetailTableData[]>([]);
  const { addToast } = useContext(NotifsContext);
  const [selectedNumAgr, setSelectedNumAgr] = useState<RetailTableData[]>([]);

  const [ajouterPdv, { isLoading }] = useAddPdvMutation();
  const { data, isLoading: isLoadingData } = useGetListRetailersQuery({
    num: searchParams.get('number') + '',
    siren: selectedSte.siren,
  });

  useEffect(() => {
    if (data) {
      setTableData(
        data.map<RetailTableData>(({ pos_id, libelle }) => ({
          pos_id,
          libelle,
        }))
      );
    }
  }, [data, window.location]);

  const navigate = useNavigate();

  async function addPDV() {
    if (selectedNumAgr.length !== 0) {
      let data: PdvPayload[] = [];
      selectedNumAgr.map((row) => {
        data.push({
          bnppf_pos_id: row.pos_id,
          /*partner_pos_id: row.pos_id,*/
          partner_pos_id: '',
          name: row.libelle,
          business_domain: 'DISTRIB',
          employer: selectedSte.siren,
        });
      });
      let req = { siren: selectedSte.siren, reqbody: data };
      ajouterPdv(req)
        .unwrap()
        .then(() => {
          addToast &&
            addToast({
              toastType: 'success',
              children: 'Confirmation de création.',
            });
          navigate('numero-agrement');
        })
        .catch(() => {
          addToast &&
            addToast({
              toastType: 'error',
              children: `Une erreur est survenue.
          Rééssayer ultérieurement.`,
            });
        })
        .finally(() => {});
    }
  }
  const columnHelper = createColumnHelper<RetailTableData>();
  const cols = [
    columnHelper.accessor('pos_id', {
      header: () => "Numéro d'agrément",
      meta: { filterVariant: 'text' },
    }),
    columnHelper.accessor('libelle', {
      header: () => 'Libellé',
      meta: { filterVariant: 'text' },
    }),
  ] as ColumnDef<RetailTableData>[];

  const rightbtns: ButtonProps[] = [
    {
      onClick: addPDV,
      disabled: selectedNumAgr.length === 0,
      icon: <PlusCircle />,
      children: 'Ajouter',
    },
  ];

  return (
    <>
      {/* @ts-ignore */}
      <Table<RetailTableData>
        title="Liste des numéros d'agrément"
        rightbtns={rightbtns}
        columns={cols}
        columnsSort={[{ id: 'libelle', desc: false }]}
        data={tableData}
        enableFilter={true}
        isLoadingData={isLoadingData}
        onSelectionChange={setSelectedNumAgr}
      />
    </>
  );
}
